import { Chip, Stack, Typography } from '@mui/material';

import DeviceIcon from 'src/components/fragments/DeviceIcon';
import { DEFAULT_ALLOCATION_TYPE_CONFIG } from 'src/hooks/useDeviceAllocationProperties';
import { DeviceTriggerState } from 'src/hooks/usePendingDeviceTriggers';

export default function DeviceResetCardHeader({ device }: { device: DeviceTriggerState }) {
    const { allocationType, iconType, room, isPending } = device;
    const config = allocationType ? DEFAULT_ALLOCATION_TYPE_CONFIG[allocationType] : undefined;

    return (
        <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', width: '100%' }}>
            <DeviceIcon iconType={iconType} />
            <Stack sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'grey.900' }}>
                    {config?.displayName ?? 'Device'}
                </Typography>
                {room && (
                    <Typography variant="subtitle1" sx={{ color: 'grey.900' }}>
                        {room}
                    </Typography>
                )}
            </Stack>
            <Chip
                variant="outlined"
                color={isPending ? 'error' : 'success'}
                label={isPending ? 'Requires reset' : 'Reset'}
            />
        </Stack>
    );
}
